import { createSelector } from 'reselect'

const getIsStudentNameAutofilled = state => state.student.isStudentNameAutofilled

const studentLeadAutofillSelector = createSelector(
	[ getIsStudentNameAutofilled ],
	isStudentNameAutofilled => isStudentNameAutofilled
)

export default studentLeadAutofillSelector
